export default __webpack_public_path__ + "static/media/Eypaug4WUAEr2e4.aaa33642.jfif";